"use client";

import "mapbox-gl/dist/mapbox-gl.css";
import Map, { Marker, NavigationControl } from "react-map-gl/mapbox";

export default function LocationMap() {
  const MAPBOX_TOKEN = process.env.NEXT_PUBLIC_MAPBOX_TOKEN ?? 'pk.eyJ1IjoidGVsZW1hdGljczIwMjUiLCJhIjoiY201eHljdjVxMDB0ZTJqc2pua2xjZjNoNyJ9.UAYBtUMx3fB0qcA_ldh7hg';
  const latitude = 46.1967941;
  const longitude = 6.1884169;

  return (
    <div style={{ height: "600px", width: "100%" }}>
      <Map
        initialViewState={{
          longitude,
          latitude,
          zoom: 12,
        }}
        style={{ width: "100%", height: "100%" }}
        mapStyle="mapbox://styles/mapbox/light-v11"
        mapboxAccessToken={MAPBOX_TOKEN}
      >
        <NavigationControl position="top-right" />
        <Marker longitude={longitude} latitude={latitude} color="#000000ff"/>
      </Map>
    </div>
  );
}
